import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { provide } from 'vue';
import userSettings, {} from "@astina/paloma-common-ui/src/services/UserSettings";
import config from "../services/PortalConfig";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogView',
    setup(__props) {
        const settings = userSettings('paloma-ui.portal.catalog');
        const uiSettings = settings.get({ view: config.catalog.defaultView, viewMode: config.catalog.defaultViewMode });
        provide('catalogUiSettings', uiSettings);
        provide('productAttributesUiConfig', config.productAttributes);
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_component_router_view));
        };
    }
});
